import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';
import '@/assets/css/onboarding.css';
import { setActiveOnboardingDriver } from '@/store/onboarding-store';
import i18n from '../i18n';
import { scrollTablesToRight, waitForAllElements } from './waitForDomElements';

const startBillingGuide = (options = {}) => {
  const {
    onFinish = () => {},
  } = options;

  const steps = [];

  steps.push(
    {
      element: '.billing-guide-subscriptions-table',
      popover: {
        title: i18n.t('onboarding.billing.guide.subscriptions_title'),
        description: i18n.t('onboarding.billing.guide.subscriptions_description'),
      },
    },
    {
      element: '.billing-guide-subscription-details-btn-first',
      popover: {
        title: i18n.t('onboarding.billing.guide.details_title'),
        description: i18n.t('onboarding.billing.guide.details_description'),
      },
    },
    {
      element: '.billing-guide-actions-activator-first',
      popover: {
        title: i18n.t('onboarding.billing.guide.actions_title'),
        description: i18n.t('onboarding.billing.guide.actions_description'),
      },
    },
  );

  steps.push(
    {
      element: '.billing-guide-transactions-table',
      popover: {
        title: i18n.t('onboarding.billing.guide.transactions_title'),
        description: i18n.t('onboarding.billing.guide.transactions_description'),
      },
    },
    {
      element: '.billing-guide-invoice-btn-first',
      popover: {
        title: i18n.t('onboarding.billing.guide.invoice_title'),
        description: i18n.t('onboarding.billing.guide.invoice_description'),
      },
    },
  );

  const requiredSelectors = [
    '.billing-guide-transactions-table',
    '.billing-guide-invoice-btn-first',
  ];

  return waitForAllElements(requiredSelectors)
    .then((allFound) => {
      if (!allFound) {
        return false;
      }

      let isCompleted = false;

      const onboardingDriver = driver({
        showProgress: true,
        allowClose: false,
        showButtons: ['previous', 'next'],
        prevBtnText: i18n.t('onboarding.prev'),
        nextBtnText: i18n.t('onboarding.next'),
        doneBtnText: i18n.t('onboarding.done'),
        steps: steps.map((step, index) => {
          if (index === steps.length - 1) {
            return {
              ...step,
              popover: {
                ...step.popover,
                onNextClick: () => {
                  isCompleted = true;
                  onboardingDriver.destroy();
                },
              },
            };
          }
          return step;
        }),
        onDestroyed: () => {
          if (isCompleted) {
            onFinish();
          } else if (options.onDeactivated) {
            options.onDeactivated();
          }
        },
      });

      setActiveOnboardingDriver(onboardingDriver);
      scrollTablesToRight([
        '.billing-guide-subscriptions-table',
        '.billing-guide-transactions-table',
      ]);
      onboardingDriver.drive();

      return true;
    });
};

export { startBillingGuide };
export default startBillingGuide;
